import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {CurrentParameterVersionAction, StandaloneState} from '../../store/standalone';
import {selectStandaloneState} from '../../store';
import {firstValueFrom, of} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import JSZip from 'jszip';
import {catchError} from 'rxjs/operators';
import {ParametersDatabase} from "../../sqllite/databases/parameters.database";

@Injectable({
    providedIn: 'root'
})export class ParametersSynchronizer {

    private countryIsoCode: string;

    constructor(private readonly store: Store<StandaloneState>,
                private readonly parametersDatabase : ParametersDatabase,
                private readonly httpClient: HttpClient) {
    }

    public async init(countryIsoCode: string) {
        this.countryIsoCode = countryIsoCode;
        console.log("INIT ParametersSynchronizer")
        if(! await this.parametersDatabase.exists()) {
            console.log("ParametersSynchronizer lunch synchronizeNewVersion ...")
            await this.synchronizeParameters();
        } else {
            await this.parametersDatabase.loadDb();
        }
    }

    async synchronizeParameters() {
        console.time('synchronizeParameters');
        const storedEtag = (await firstValueFrom(this.store.select(selectStandaloneState))).currentParameterVersion || '';
        const headers = storedEtag ? { 'If-None-Match': storedEtag } : {};
        const response = await  firstValueFrom(
            this.httpClient
            .get(`/apiParams/v1/sync/download/${this.countryIsoCode}/latest`,
                { headers: new HttpHeaders(headers), observe: 'response', responseType: 'blob' })
                .pipe(catchError(err => of(err)))
        );
        if (response.status === 200 && response.headers.has('ETag')) {
            const zip = await JSZip.loadAsync(response.body!);
            const fileName = Object.keys(zip.files)[0];
            const dbFile = await zip.files[fileName].async('uint8array');
            await this.parametersDatabase.saveAndLoadDb(dbFile);
            this.store.dispatch(new CurrentParameterVersionAction(response.headers.get('ETag')));
            console.log('Parameters cache has been synchronized');
        } else if (response.status === 304) {
            console.log('Fichier des parameters est déjà à jour, pas besoin de retélécharger.');
            await this.parametersDatabase.loadDb();
        }
        console.timeEnd('synchronizeParameters');
    }

}

